import React from 'react';
import { useTranslation } from 'react-i18next';
import { makeStyles } from '@material-ui/core/styles';

import Helpers from '../../theme/Helpers';
import CustomTooltip from '../Tooltip/CustomTooltip';
import Colors from '../../theme/Colors';

const useStyles = makeStyles({
  item: {
    background: '#202C3D',
    borderRadius: 6,
    padding: 12.5,
    position: 'relative',
    marginTop: 10,
    ...Helpers.fillRowCenter,
    ...Helpers.mainSpaceBetween,
    fontFamily: 'Montserrat',
  },
});

const CardShopSideCartStatic = (props) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const { product, removeStatic } = props;

  return (
    <div className={classes.item}>
      <div style={{ ...Helpers.fillRowCenter }}>
        <div style={{ fontSize: 22, fontWeight: 400 }}>
          {product.amount}
        </div>
        <div style={{ marginLeft: 15, marginRight: 10 }}>
          <img src={`${product.image}?width=38`} alt="Product" />
        </div>
        <div>
          <div style={{ fontWeight: 400 }}>
            {t(product.name)}
          </div>
          <div style={{ fontWeight: 300, fontSize: 14, color: Colors.halfWhite }}>
            {t(product.description)}
          </div>
        </div>
      </div>

      <div style={Helpers.fillRowCross}>
        <div style={{ marginRight: 18 }}>
          <div style={{ fontSize: 14, color: Colors.halfWhite, fontWeight: 300 }}>
            {t('costs')}
          </div>
          <div style={{ fontWeight: 400 }}>
            {((product.discounted_price ? product.discounted_price : product.unit_price) / 100).toFixed(2)
            .toString()
            .replace('.', ',')} €
          </div>
        </div>
        <CustomTooltip title={t('delete')}>
          <i
            className="fa-light fa-xmark"
            onClick={() => removeStatic(product)}
            style={{ fontSize: 18, cursor: 'pointer', marginBottom: 20 }}
          />
        </CustomTooltip>
      </div>
    </div>
  );
};

export default CardShopSideCartStatic;